export default __webpack_public_path__ + "531c9f997c14172d9dfa5c043ce1f8264db2f91a69b2818a4928e618619ddf31.svg";